<template>
    <div style="margin:0 -12px;">
        <div v-if="is_send" class="container-fluid" style="position:absolute; background:#FF2AA3;color:#fff;z-index:999999999999"
            id="send_alert">
            <div class="row">
                <div class="col text-center" style="padding:15px 0;">
                    <small>
                        メールを送信しました。確認をお願いします。
                    </small>
                </div>
            </div>
        </div>
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <i class="bi bi-chevron-left" onclick="window.location.href = '/setting'"></i>
                    </div>
                    <div class="col text-center">
                        <h5>メールアドレス設定</h5>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <br>
            <div class="container-fluid" style="padding-top:56px;">
                <div class="row justify-content-center">
                    <div class="col-11">
                        <div style="padding:5px 0;">
                            <span style="font-size:12px;color:#5538ee">設定中のメールアドレス</span><br>
                            <span style="font-size:13px;color:#9990FF">{{ user.email }}</span>
                        </div>
                        <br>
                        <input type="email" class="luna-form-control" id="mail" name="mail" placeholder="登録/変更するメールアドレスを入力"
                            v-model="mail" />
                        <br />
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-8">
                        <div class="d-grid gap-2" style="padding: 0 5px;">
                            <button type="button" class="btn btn-luna-d disabled" style="font-size:18px; padding:12px 0;"
                                v-if="isInValidEmail">メール認証をする</button>
                            <button type="button" class="btn btn-luna" style="font-size:18px; padding:12px 0;"
                                @click="setAuthEmail()" v-else>メール認証をする</button>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <br>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: [],
            mail: '',
            is_error: false,
            is_error_none: false,
            is_chenge: false,
            is_load: false,
            is_send: false,
        };
    },
    methods: {
        async fetchUsers() {
            let response = await axios.get("/api/user/status")
                .then((response) => {
                    this.user = response.data.user
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザー情報の取得に失敗しました");
                    }
                })
        },
        async setAuthEmail() {
            await axios.post("/api/auth/email/conf", {
                email: this.mail,
            })
                .then((response) => {
                    if (response.data.res == '546') {
                        this.$showErrorToast('すでに使用されているメールアドレスです。');
                    } else if (response.data.res == '547') {
                        this.$showErrorToast(response.data.message);
                    } else {
                        this.is_send = true;
                        $('#send_alert').slideDown()
                        setTimeout(() => {
                            $('#send_alert').slideUp("slow")
                        }, 3000)
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else if (error.response && error.response.status == 422) {
                        // バリデーションエラーの処理
                        if (error.response.data.errors && error.response.data.errors.email) {
                            // メールアドレスに関するエラーメッセージを表示
                            this.$showErrorToast(error.response.data.errors.email[0]);
                        } else {
                            this.$showErrorToast('入力内容に誤りがあります。');
                        }
                    }
                    else {
                        this.$showErrorToast('メールの送信に失敗しました。');
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.fetchUsers()
                            $('#send_alert').slideUp(0)
                        })
                    .catch((error) => {
                        this.$showErrorToast('ログインに失敗しました。');
                    })
            }
            else {
                this.fetchUsers()
                $('#send_alert').slideUp(0)
            }
        }
        else {
            this.fetchUsers()
            $('#send_alert').slideUp(0)
        }
    },
    computed: {
        isInValidEmail() {
            //メールアドレスとして判定される文字列と記号の組み合わせを定数化
            const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
            //指定した組み合わせになっていなかった場合判定を返す。
            return !reg.test(this.mail);
        },
    }
};
</script>
<style scoped>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    padding-top: 20px;
    height: 60px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
